"use client"
import { ErrorBoundaryFallback, ErrorBoundaryFallbackProps } from "src/components/error/ErrorBoundaryFallback"
import { MinimalLayout } from "src/components/layout/MinimalLayout"

// Error components must be Client Components

export default function ErrorPage(props: ErrorBoundaryFallbackProps) {
  return (
    <MinimalLayout>
      <ErrorBoundaryFallback {...props} />
    </MinimalLayout>
  )
}
